<template>
  <div style="padding: 20px 160px">
    <h3 style="text-align: center">活动管理</h3>
    <el-tabs type="border-card" @tab-click="handleClick">
      <!-- 秒杀管理 -->
      <el-tab-pane label="秒杀管理" style="padding: 20px 40px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="title"
              placeholder="请输入秒杀主题"
              size="medium"
              clearable
              @keyup.enter.native="getSeckill"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getSeckill"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" size="medium" @click="handleAdd"
              >添加秒杀活动</el-button
            >
          </el-col>

          <el-col :span="1.5">
            <el-button type="danger" size="medium" @click="deleteChiose"
              >选中删除</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="info" size="medium" @click="AddUser"
              >活动用户</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="warning" size="medium" @click="checkOrders"
              >秒杀订单</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataSeckill"
          style="width: 100%; margin-top: 20px"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="title" label="秒杀主题"> </el-table-column>
          <el-table-column
            prop="stime"
            label="秒杀开始时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="etime"
            label="秒杀结束时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inserttime"
            label="秒杀创建时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              ></el-button>
              <el-button
                type="success"
                size="mini"
                @click="toSeckill(scope.row)"
              >
                管理秒杀药品
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="SizeChange"
          @current-change="CurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-tab-pane>
      <!-- 团购管理 -->
      <el-tab-pane label="团购管理" style="padding: 20px 40px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="titleTg"
              placeholder="请输入团购标题"
              size="medium"
              clearable
              @keyup.enter.native="getTgLx"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getTgLx"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" size="medium" @click="handleAddTgLx"
              >添加团购活动</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="danger" size="medium" @click="deleteChioseTgLx"
              >选中删除</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="warning" size="medium" @click="openTgOrder"
              >团购订单</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="tableTgLx"
          style="width: 100%; margin-top: 20px"
          border
          @selection-change="TglxChange"
        >
          <el-table-column type="selection" width="55" align="  ">
          </el-table-column>
          <el-table-column prop="title" label="团购主题"> </el-table-column>
          <el-table-column
            prop="stime"
            label="团购开始时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="etime"
            label="团购结束时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="state"
            label="是否启用"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeState(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditTgLx(scope.row)"
              ></el-button>
              <el-button
                type="success"
                size="mini"
                @click="toTgDrug(scope.row)"
              >
                管理团购药品
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDeleteTgLx(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="TgLxSizeChange"
          @current-change="TgLxCurrentChange"
          :current-page="TgIndex"
          :page-sizes="[10, 20]"
          :page-size="TgSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="TgTotal"
        >
        </el-pagination>
      </el-tab-pane>
      <!-- 订单改价 -->
      <el-tab-pane label="订单改价">
        <div
          v-show="showVue"
          style="width: 1250px; margin: 0 auto; margin-top: 50px"
        >
          <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
            <div
              class="mb-2"
              style="
                margin-left: 20px;
                display: flex;
                align-items: center;
                margin-top: 15px;
              "
            >
              <span>序列号:</span>
              <input
                type="text"
                class="input_form-control ml-2"
                v-model="gatherNo"
              />
              <span class="ml-2"> 客户名称: </span>
              <input
                type="text"
                class="input_form-control ml-2"
                v-model="customerName"
              />
              <span class="ml-2">药品名称:</span>
              <input
                type="text"
                class="input_form-control ml-2"
                v-model="drugName"
              />
              <button
                class="bg-primary button_zi heit ml-2"
                @click="getClerkStoreGoodsQuery()"
              >
                查询
              </button>
            </div>
            <table v-if="showPage" class="table table-striped table-hover">
              <thead>
                <tr style="white-space: nowrap" class="text-center">
                  <th>序列号</th>
                  <th>客户名称</th>
                  <th>库区</th>
                  <th>药品名称</th>
                  <th>产地</th>
                  <th>规格</th>
                  <th>进价</th>
                  <th style="color: green">批量价</th>
                  <!-- <th>批零价</th> -->
                  <th>单价</th>
                  <th>数量</th>
                  <th>金额</th>
                  <th>批准文号</th>
                  <th>包装</th>
                  <th>批号</th>
                  <th>远程订单</th>
                  <!-- <th>库存id</th> -->
                  <th>修改价格</th>
                  <th>确认修改</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td class="jz_middle">{{ item.gatherNo }}</td>
                  <td class="jz_middle">{{ item.customerName }}</td>
                  <td class="jz_middle">
                    {{ item.storeNo }}
                  </td>
                  <td class="jz_middle">
                    {{ item.drugName }}
                  </td>
                  <td class="jz_middle">{{ item.factory }}</td>
                  <td class="jz_middle">{{ item.spec }}</td>
                  <td class="jz_middle">{{ item.purchPrice }}</td>
                  <td class="jz_middle" style="color: green">
                    {{ item.tradePrice }}
                  </td>
                  <!-- <td class="jz_middle">{{item.retailPrice}}</td> -->
                  <td class="jz_middle">{{ item.price }}</td>
                  <td class="jz_middle">{{ item.num }}</td>
                  <td class="jz_middle">{{ item.amount }}</td>
                  <td class="jz_middle">{{ item.approvalNo }}</td>
                  <td class="jz_middle">{{ item.pack }}</td>
                  <td class="jz_middle">{{ item.batchNo }}</td>
                  <td class="jz_middle">{{ item.state | status }}</td>
                  <!-- <td class="jz_middle">{{item.storeID}}</td> -->
                  <td class="jz_middle">
                    <input
                      type="text"
                      class="text-center"
                      style="width: 60px"
                      v-model="item.value"
                    />
                  </td>
                  <td class="jz_middle">
                    <button
                      class="bg-primary button_zi heit"
                      @click="GetTiaoJia(index)"
                    >
                      确认
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else>
              <img
                src="../../static/images/wushuju.jpg"
                style="
                  width: 300px;
                  height: 300px;
                  display: block;
                  margin: 0 auto;
                "
                alt=""
              />
            </div>

            <p class="text-center">
              <img
                src="../../static/images/tuding.png"
                style="width: 1.5rem; height: 1.5rem"
                alt=""
              />
            </p>
          </div>
        </div>
        <!-- 详情内容 -->
        <div>
          <transition name="fade">
            <loading v-show="isLoading"> </loading>
          </transition>
        </div>
        <!-- 这里是弹出调价框 -->
        <div
          class="modal fade"
          id="myModal_jia"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div
              class="modal-content"
              style="
                width: 100%;
                position: relative;
                top: 150px;
                min-width: 500px;
              "
            >
              <div class="modal-header">
                <button
                  type="button"
                  class="close m-0 p-1"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-header">
                    <div class="font">
                      <span class="ml-2"> 以前的批量价为 </span>
                      <span style="color: blue; font-weight: bold" class="ml-2">
                        {{ BeforePrice }}
                      </span>
                      <span class="ml-2"> 修改批量价为 </span>
                      <span style="color: red; font-weight: bold" class="ml-2">
                        {{ (ModifyPrice * 1.028).toFixed(3) }}
                      </span>
                    </div>
                  </div>
                  <div class="card-body">
                    <div>
                      <!-- <p>
                    <select v-model="phoneNumber" class="input_form-control1">
                      <option value="">请选择手机号码</option>
                      <option
                        v-for="(item, index) in phones"
                        :key="index"
                        :value="item.tel"
                        v-text="item.tel"
                      ></option>
                    </select>

                    <button
                      class="btn btn-primary ml-5"
                      :disabled="disabled"
                      @click.prevent="getCode()"
                    >
                      {{ btnText }}
                    </button>
                  </p>
                  <p class="mt-4">
                    <input
                      type="text"
                      class="input_form-control1"
                      placeholder="请输入收到的验证码"
                      v-model="securityCode"
                    />
                  </p> -->
                      <p class="text-center mt-4">
                        <button
                          class="btn btn-primary"
                          :disabled="disabled1"
                          @click="Modification()"
                        >
                          确认修改此价格
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                >
                  <span aria-hidden="true"></span>关闭
                </button>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="单品包邮" style="padding: 20px 40px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="titleBy"
              placeholder="请输入活动标题"
              size="medium"
              clearable
              @keyup.enter.native="getByLx"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getByLx"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" size="medium" @click="handleAddByLx"
              >添加活动</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="danger" size="medium" @click="deleteChioseByLx"
              >选中删除</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="warning" size="medium" @click="openByOrder"
              >活动订单</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="tableByLx"
          style="width: 100%; margin-top: 20px"
          border
          @selection-change="BylxChange"
        >
          <el-table-column type="selection" width="55" align="  ">
          </el-table-column>
          <el-table-column prop="title" label="活动主题"> </el-table-column>
          <el-table-column
            prop="stime"
            label="活动开始时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="etime"
            label="活动结束时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="state"
            label="是否启用"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeByState(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditByLx(scope.row)"
              ></el-button>
              <el-button
                type="success"
                size="mini"
                @click="toByDrug(scope.row)"
              >
                管理活动药品
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDeleteByLx(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="ByLxSizeChange"
          @current-change="ByLxCurrentChange"
          :current-page="ByIndex"
          :page-sizes="[10, 20]"
          :page-size="BySize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="ByTotal"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="产品展示" style="padding: 20px 40px">
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col :span="2.5">
            <el-input
              v-model="cpForm.ypmc"
              placeholder="请输入药品名称"
              clearable
              size="medium"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-input
              v-model="cpForm.cdmc"
              placeholder="请输入产地名称"
              clearable
              size="medium"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-input
              v-model="cpForm.gg"
              placeholder="请输入规格"
              clearable
              size="medium"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getList"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" size="medium" @click="showCpModel"
              >添加药品</el-button
            >
          </el-col>
        </el-row>

        <el-table :data="cpData" border>
          <el-table-column label="图片" width="135" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" width="220" trigger="hover">
                <el-image
                  style="width: 80px; height: 80px"
                  :src="baseUrl + scope.row.image"
                  slot="reference"
                ></el-image>
                <el-image
                  style="width: 200px; height: 200px"
                  :src="baseUrl + scope.row.image"
                ></el-image>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="ypmc"
            label="药品名称"
            header-align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="cdmc"
            label="产地名称"
            header-align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column prop="gg" label="规格" align="center" width="100">
          </el-table-column>
          <el-table-column
            prop="boss"
            label="代理商号"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="dj" label="单价" align="center" width="80">
          </el-table-column>
          <el-table-column prop="ph" label="批号" align="center" width="90">
          </el-table-column>
          <el-table-column prop="sl" label="库存" align="center" width="70">
          </el-table-column>
          <el-table-column
            prop="topindex"
            label="置顶数"
            align="center"
            width="70"
          >
          </el-table-column>
          <el-table-column
            prop="isretail"
            label="零/整"
            align="center"
            width="70"
          >
            <template slot-scope="scope">
              {{ scope.row.isretail ? "零" : "整" }}
            </template>
          </el-table-column>
          <el-table-column prop="yxq" label="有效期" width="90" align="center">
          </el-table-column>
          <el-table-column
            prop="scrq"
            label="生产日期"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="pzwh" label="批准文号" align="center">
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleCpEdit(scope.row)"
              ></el-button>
              <el-button
                type="success"
                size="mini"
                @click="handleTop(scope.row)"
                >置顶</el-button
              >
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDel(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="cpDrugCurrentChange"
          :current-page="cpForm.pageIndex"
          :page-size="20"
          background
          layout="total, prev, pager, next"
          :total="cpTotal"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- 秒杀活动 -->
    <el-dialog
      :title="isAdd ? '添加秒杀活动' : '修改秒杀活动'"
      :visible.sync="dialogSeckill"
      :width="'800px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="form" :model="formSeckill" label-width="120px">
          <el-form-item label="秒杀标题：" class="is-required">
            <el-input
              v-model="formSeckill.title"
              placeholder="请输入秒杀标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="秒杀时间：" class="is-required">
            <el-date-picker
              v-model="formSeckill.stime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            <el-date-picker
              v-model="formSeckill.etime"
              type="datetime"
              style="margin-left: 20px"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogSeckill = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 活动用户 -->
    <el-dialog
      title="活动用户"
      :visible.sync="dialogUser"
      :width="'800px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input
              v-model="username"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getUser"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" @click="getUser" size="medium"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" @click="manageUser" size="medium"
              >添加</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="danger" @click="DelChioseUser" size="medium"
              >删除选中</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataUser"
          style="width: 100%; margin-top: 20px"
          border
          @selection-change="userChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="username" label="用户名"> </el-table-column>
          <el-table-column prop="khmc" label="客户名称"> </el-table-column>
          <el-table-column
            prop="inserttime"
            align="center"
            label="时间"
            width="160"
          >
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="userDelete(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="userSizeChange"
          @current-change="userCurrentChange"
          :current-page="userIndex"
          :page-sizes="[10, 20]"
          :page-size="userSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="userTotal"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="添加活动用户"
        :visible.sync="dialogManageUser"
        :width="'400px'"
        :close-on-click-modal="false"
        append-to-body
      >
        <div>
          <el-form :model="formUser" label-width="80px">
            <el-form-item label="用户名：" class="is-required">
              <el-input v-model="formUser.user"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="dialogManageUser = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 秒杀订单 -->
    <el-dialog
      title="秒杀订单"
      :visible.sync="dialogSecOrder"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="secUser"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getSecOrder"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="secStime"
              type="date"
              format="yyyy-MM-dd"
              size="medium"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="secEtime"
              type="date"
              size="medium"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getSecOrder"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataSecOrder"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="orderid" label="订单编号"> </el-table-column>
          <el-table-column prop="erpuserid" label="客户编号" width="100px">
          </el-table-column>
          <el-table-column prop="username" label="用户名" width="120px">
          </el-table-column>
          <el-table-column
            prop="zje"
            label="总金额"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="销售金额"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xlh2"
            label="序列号"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="company" label="公司名称"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="prop"
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                @click="checkSecDetail(scope.row)"
                >订单详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="secOrderSizeChange"
          @current-change="secOrderCurrentChange"
          :current-page="secOrderIndex"
          :page-sizes="[10, 20]"
          :page-size="secOrderSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="secOrderTotal"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="秒杀订单详情"
        :visible.sync="dialogSecDetail"
        :width="'1300px'"
        append-to-body
        center
        :close-on-click-modal="false"
      >
        <div>
          <el-table
            :data="dataSecDetail"
            style="width: 100%"
            border
            :row-class-name="tableRowClassNameSec"
          >
            <el-table-column prop="ypmc" label="药品名称" header-align="center">
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" header-align="center">
            </el-table-column>
            <el-table-column prop="gg" label="规格" header-align="center">
            </el-table-column>
            <el-table-column prop="ph" label="批号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="dj" label="原价" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zsje"
              label="秒杀单价"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsje | addZero(scope.row.zsje) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="buynum"
              label="购买数量"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="xjje"
              label="小结金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="zsxjje"
              label="秒杀总金额"
              width="95"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsxjje | addZero(scope.row.zsxjje) }}
              </template>
            </el-table-column>
            <el-table-column prop="bz" label="包装" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="scrq2"
              label="生产日期"
              width="90"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" header-align="center">
            </el-table-column>
            <el-table-column prop="rq" label="下单时间" header-align="center">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 团购活动 -->
    <el-dialog
      :title="isTgAdd ? '添加团购活动' : '修改团购活动'"
      :visible.sync="dialogTgLx"
      :width="'800px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formTgLx" label-width="100px">
        <el-form-item label="团购标题：" class="is-required">
          <el-input
            v-model="formTgLx.title"
            placeholder="请输入团购标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" class="is-required">
          <el-date-picker
            v-model="formTgLx.stime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="formTgLx.etime"
            type="datetime"
            style="margin-left: 20px"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：" class="is-required">
          <el-radio-group v-model="formTgLx.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogTgLx = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 团购订单 -->
    <el-dialog
      title="团购订单"
      :visible.sync="dialogTgOrder"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              v-model="TgOrderUsername"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getTgOrder"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-select v-model="TgGs" placeholder="请选择公司">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="TgStime"
              type="date"
              format="yyyy-MM-dd"
              size="medium"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="TgEtime"
              type="date"
              size="medium"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getTgOrder"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataTgOrder"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            prop="username"
            label="用户名"
            width="100"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="erpuserid"
            label="erpID"
            width="100"
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="xlh2"
            label="序列号"
            width="100"
            header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.xlh2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zje"
            label="采购金额"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.zje }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="销售金额"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.zsje }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="收货地址"
            header-align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="shphone"
            label="联系电话"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="shr" label="收货人" width="80" align="center">
          </el-table-column>
          <!-- <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="state" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <div :style="scope.row.state == -1 ? 'color:red;' : ''">
                {{ scope.row.state | TgOrderState(scope.row.state) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gs" label="公司" width="120" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.gs | TgGs(scope.row.gs) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="bz"
            label="备注"
            width="100"
            header-align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="110"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditTgOrder(scope.row)"
              ></el-button> -->
              <el-button
                type="success"
                @click="checkTgDetail(scope.row)"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="TgOrderSizeChange"
          @current-change="TgOrderCurrentChange"
          :current-page="TgOrderIndex"
          :page-sizes="[10, 20]"
          :page-size="TgOrderSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="TgOrderTotal"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="团购订单详情"
        :visible.sync="dialogTgDetail"
        :width="'1300px'"
        center
        append-to-body
        :close-on-click-modal="false"
      >
        <div>
          <el-table
            :data="dataTgDetail"
            style="width: 100%"
            border
            :row-class-name="tableRowClassNameTg"
          >
            <el-table-column prop="ypmc" label="药品名称" header-align="center">
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" header-align="center">
            </el-table-column>
            <el-table-column prop="gg" label="规格" header-align="center">
            </el-table-column>
            <el-table-column prop="ph" label="批号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="dj" label="原价" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zsje"
              label="团购单价"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsje | addZero(scope.row.zsje) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="buynum"
              label="购买数量"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="xjje"
              label="小结金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="zsxjje"
              label="团购总金额"
              width="95"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsxjje | addZero(scope.row.zsxjje) }}
              </template>
            </el-table-column>
            <el-table-column prop="bz" label="包装" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="scrq2"
              label="生产日期"
              width="90"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" header-align="center">
            </el-table-column>
            <el-table-column prop="rq" label="下单时间" header-align="center">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!-- <el-dialog
        title="修改订单状态"
        :visible.sync="dialogTgState"
        :width="'600px'"
        append-to-body
        center
        :close-on-click-modal="false"
      >
        <div>
          <el-form :model="formTgOrder" label-width="110px">
            <el-form-item label="订单状态：">
              <el-radio-group v-model="formTgOrder.state">
                <el-radio :label="0">初始状态</el-radio>
                <el-radio :label="1">已付款</el-radio>
                <el-radio :label="2">生成订单</el-radio>
                <el-radio :label="-1">订单作废</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="formTgOrder.bz"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="dialogTgState = false">取 消</el-button>
          <el-button type="primary" @click="submitState"
            >确 定</el-button
          >
        </div>
      </el-dialog> -->
    </el-dialog>
    <!-- 单品包邮活动 -->
    <el-dialog
      :title="isByAdd ? '添加活动' : '修改活动'"
      :visible.sync="dialogByLx"
      :width="'800px'"
      center
      :close-on-click-modal="false"
    >
      <el-form :model="formByLx" label-width="100px">
        <el-form-item label="活动标题：" class="is-required">
          <el-input
            v-model="formByLx.title"
            placeholder="请输入活动标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" class="is-required">
          <el-date-picker
            v-model="formByLx.stime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="formByLx.etime"
            type="datetime"
            style="margin-left: 20px"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：" class="is-required">
          <el-radio-group v-model="formByLx.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogByLx = false">取 消</el-button>
        <el-button type="primary" @click="handleBySubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="活动订单"
      :visible.sync="dialogByOrder"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              v-model="ByOrderUsername"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getByOrder"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-select v-model="TgGs" placeholder="请选择公司">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="ByStime"
              type="date"
              format="yyyy-MM-dd"
              size="medium"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="ByEtime"
              type="date"
              size="medium"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getByOrder"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataByOrder"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            prop="username"
            label="用户名"
            width="100"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="erpuserid"
            label="erpID"
            width="100"
            header-align="center"
          ></el-table-column>
          <el-table-column
            prop="xlh2"
            label="序列号"
            width="100"
            header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.xlh2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zje"
            label="采购金额"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.zje }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="销售金额"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.zsje }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="收货地址"
            header-align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="shphone"
            label="联系电话"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="shr" label="收货人" width="80" align="center">
          </el-table-column>
          <!-- <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="state" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <div :style="scope.row.state == -1 ? 'color:red;' : ''">
                {{ scope.row.state | TgOrderState(scope.row.state) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gs" label="公司" width="120" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.gs | TgGs(scope.row.gs) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="bz"
            label="备注"
            width="100"
            header-align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="110"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditTgOrder(scope.row)"
              ></el-button> -->
              <el-button
                type="success"
                @click="checkByDetail(scope.row)"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="ByOrderSizeChange"
          @current-change="ByOrderCurrentChange"
          :current-page="ByOrderIndex"
          :page-sizes="[10, 20]"
          :page-size="ByOrderSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="ByOrderTotal"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="活动订单详情"
        :visible.sync="dialogByDetail"
        :width="'1300px'"
        center
        append-to-body
        :close-on-click-modal="false"
      >
        <div>
          <el-table
            :data="databyDetail"
            style="width: 100%"
            border
            :row-class-name="tableRowClassNameBy"
          >
            <el-table-column prop="ypmc" label="药品名称" header-align="center">
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" header-align="center">
            </el-table-column>
            <el-table-column prop="gg" label="规格" header-align="center">
            </el-table-column>
            <el-table-column prop="ph" label="批号" width="80" align="center">
            </el-table-column>
            <el-table-column prop="dj" label="原价" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zsje"
              label="活动单价"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsje | addZero(scope.row.zsje) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="buynum"
              label="购买数量"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="xjje"
              label="小结金额"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="zsxjje"
              label="采购总金额"
              width="95"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.zsxjje | addZero(scope.row.zsxjje) }}
              </template>
            </el-table-column>
            <el-table-column prop="bz" label="包装" width="60" align="center">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="scrq2"
              label="生产日期"
              width="90"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              width="80"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" header-align="center">
            </el-table-column>
            <el-table-column prop="rq" label="下单时间" header-align="center">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!-- <el-dialog
        title="修改订单状态"
        :visible.sync="dialogTgState"
        :width="'600px'"
        append-to-body
        center
        :close-on-click-modal="false"
      >
        <div>
          <el-form :model="formTgOrder" label-width="110px">
            <el-form-item label="订单状态：">
              <el-radio-group v-model="formTgOrder.state">
                <el-radio :label="0">初始状态</el-radio>
                <el-radio :label="1">已付款</el-radio>
                <el-radio :label="2">生成订单</el-radio>
                <el-radio :label="-1">订单作废</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="formTgOrder.bz"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="dialogTgState = false">取 消</el-button>
          <el-button type="primary" @click="submitState"
            >确 定</el-button
          >
        </div>
      </el-dialog> -->
    </el-dialog>

    <!-- 添加产品展示 -->
    <el-dialog
      :title="isCpAdd ? '添加促销品种' : '修改促销品种'"
      :visible.sync="dialogCpDrug"
      :width="'900px'"
      :close-on-click-modal="false"
    >
      <el-form :model="formCpDrug" label-width="120px">
        <el-form-item label="药品名称：">
          <el-input
            v-model="formCpDrug.ypmc"
            style="width: 60%"
            disabled
          ></el-input>
          <el-button
            type="success"
            style="margin-left: 30px"
            v-if="isCpAdd"
            @click="chioseDrug"
            >选择药品</el-button
          >
        </el-form-item>
        <el-form-item label="产地名称：">
          <el-input v-model="formCpDrug.cdmc" disabled></el-input>
        </el-form-item>
        <el-form-item label="规格：">
          <el-input v-model="formCpDrug.gg" disabled></el-input>
        </el-form-item>
        <el-form-item label="批准文号：">
          <el-input v-model="formCpDrug.pzwh" disabled></el-input>
        </el-form-item>
        <el-form-item label="批号：">
          <el-input v-model="formCpDrug.ph" disabled></el-input>
        </el-form-item>
        <el-form-item label="库存：" v-if="isAdd">
          <el-input v-model="formCpDrug.sl" disabled></el-input>
        </el-form-item>
        <el-form-item label="生产日期：">
          <el-input v-model="formCpDrug.scrq" disabled></el-input>
        </el-form-item>
        <el-form-item label="有效期：">
          <el-input v-model="formCpDrug.yxq" disabled></el-input>
        </el-form-item>
        <el-form-item label="零/整：">
          <el-radio-group v-model="formCpDrug.isretail" disabled>
            <el-radio :label="0">整货</el-radio>
            <el-radio :label="1">零货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="置顶数" class="is-required">
          <el-input v-model.number="formCpDrug.topindex"></el-input>
        </el-form-item>
        <el-form-item label="上传图片：" class="is-required">
          <el-upload
            :class="{ hide: hideUpload }"
            action=""
            list-type="picture-card"
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="uploadFile"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogCpDrug = false">取 消</el-button>
        <el-button v-if="isCpAdd" type="primary" @click="AddCxList"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="UpdateCxList">确 定</el-button>
      </div>
      <el-dialog
        title="选择促销药品"
        :visible.sync="dialogDrug"
        :width="'1300px'"
        :close-on-click-modal="false"
        append-to-body
        center
      >
        <div>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-input
                v-model="drugForm.keys"
                placeholder="请输入药品名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="drugForm.cdmc"
                placeholder="请输入产地名称"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="drugForm.gg"
                placeholder="请输入药品规格"
                size="medium"
                clearable
                @keyup.enter.native="getDrug"
              ></el-input>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" size="medium" @click="getDrug"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-table
            :data="dataDrug"
            style="width: 100%; margin-top: 20px"
            v-loading="drugLoading"
            border
          >
            <el-table-column prop="ypmc" label="药品名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cdmc" label="产地名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="gg"
              label="药品规格"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="boss"
              label="BOSS号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="dj" label="单价" align="center" width="80">
            </el-table-column>
            <el-table-column prop="sl" label="库存" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="zbz"
              label="中包装"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="bz" label="包装" align="center" width="80">
            </el-table-column>
            <el-table-column
              prop="isretail"
              label="零/整"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isretail ? "零" : "整" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="scrq"
              label="生产日期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column prop="pzwh" label="批准文号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="mini"
                  @click="determine(scope.row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="drugSizeChange"
            @current-change="drugCurrentChange"
            :current-page="drugForm.pageIndex"
            :page-sizes="[10, 20]"
            :page-size="drugForm.pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="DrugTotal"
          >
          </el-pagination>
        </div>
        <div slot="footer">
          <el-button @click="dialogDrug = false">取 消</el-button>
          <el-button type="primary" @click="dialogDrug = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog
      title="置顶药品"
      :visible.sync="dialogTop"
      :width="'600px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="formTop" label-width="100px">
          <el-form-item label="置顶数：" class="is-required">
            <el-input v-model="formTop.topindex"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogTop = false">取 消</el-button>
        <el-button type="primary" @click="submitTop">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
export default {
  data() {
    return {
      baseUrl: "http://hyey.cn",
      title: "", //秒杀主题
      pageIndex: 1, //秒杀Index
      pageSize: 20, //秒杀Size
      total: 0, //秒杀总数
      dataSeckill: [], //秒杀活动的列表
      isAdd: true, //判断是添加还是修改
      dialogSeckill: false, //秒杀活动弹出框
      formSeckill: {
        //秒杀活动参数
        title: "",
        stime: "",
        etime: "",
      },
      multipleSelection: [], //秒杀活动选中的id数据
      dialogUser: false, //秒杀用户弹出框
      username: "", //秒杀用户的用户名
      userIndex: 1, //用户的Index
      userSize: 20, //用户的Size
      userTotal: 0, //用户的总数
      dataUser: [], //活动用户的列表
      dialogManageUser: false, //添加活动用户的弹出框
      formUser: {
        user: "",
      },
      userSelection: [], //活动用户选中的id数据
      dialogSecOrder: false, //秒杀订单的弹出框
      secStime: "", //秒杀订单开始时间
      secEtime: "", //秒杀订单结束时间
      secOrderIndex: 1, //秒杀订单Index
      secOrderSize: 20, //秒杀订单Size
      secOrderTotal: 0, //秒杀订单总数
      dialogSecDetail: false, //秒杀订单详情的弹出框
      dataSecDetail: [], //秒杀订单详情列表
      secUser: "", //查询秒杀订单的username
      dataSecOrder: [], //秒杀订单列表
      searchForm: {
        supplierNum: "",
      }, //搜索内容
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      showPage: true,
      details: [],
      totalLimitMoney: "",
      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数
      gatherNo: "", //序列号
      ModifyPrice: "", //修改价格的值
      BeforePrice: "", //之前的价格
      id: "",
      gatherNoCount: "",
      StoreNo: "",
      storeID: "",
      state: "",
      index: "",
      customerName: "",
      netOrderNo: "",
      drugName: "",
      showVue: false,
      totalCount: 0,
      phoneNumber: "", //选中的手机号码
      securityCode: "", //验证码
      phones: [],
      disabled: false,
      disabled1: false,
      titleTg: "", //团购标题
      TgIndex: 1, //团购页码
      TgSize: 20,
      TgTotal: 0,
      tableTgLx: [], //团购类型列表
      isTgAdd: false, //判断是添加还是修改
      dialogTgLx: false, //添加/修改团购活动的弹窗
      formTgLx: {
        title: "",
        stime: "",
        etime: "",
        state: 0,
        lx: 2,
      },
      initForm: {},
      TgLxSelection: [], //团购类型被选中的id
      TgStime: "", //查询团购订单的开始时间
      TgEtime: "", //查询团购订单的结束时间
      TgOrderIndex: 1,
      TgOrderSize: 20,
      TgOrderTotal: 0,
      dialogTgDetail: false, //团购订单详情的弹出框
      dataTgDetail: [], //团购订单详情列表
      TgOrderUsername: "", //查询团购订单的用户名
      dataTgOrder: [], //团购订单数据
      dialogTgOrder: false,

      cpData: [], // 产品展示数据
      cpForm: {
        ypmc: "",
        cdmc: "",
        gg: "",
        pageIndex: 1,
      },
      dialogCpDrug: false,
      formCpDrug: {
        ypmc: "",
        cdmc: "",
        gg: "",
        pzwh: "",
        ph: "",
        sl: 0,
        scrq: "",
        isretail: 0,
        yxq: "",
        image: "",
        drugid: "",
        topindex: 0,
      },
      fileList: [],
      isCpAdd: true, // 判断是添加还是修改
      dialogDrug: false,
      drugForm: {
        keys: "",
        cdmc: "",
        gg: "",
        pageIndex: 1,
        pageSize: 20,
      },
      dataDrug: [],
      drugLoading: false,
      hideUpload: false,
      dialogTop: false,
      formTop: {
        id: "",
        topindex: 0,
        image: "",
      },
      DrugTotal: 0,
      cpTotal: 0,

      TgGs: -1,
      options: [
        {
          value: -1,
          label: "全部（请选择公司）",
        },
        {
          value: 0,
          label: "电子商务公司",
        },
        {
          value: 2,
          label: "工业公司",
        },
        {
          value: 3,
          label: "西药公司",
        },
        {
          value: 4,
          label: "新特药公司",
        },
        {
          value: 5,
          label: "药品公司",
        },
        {
          value: 6,
          label: "药材公司",
        },
      ],
      formTgOrder: {
        id: 0,
        state: 0,
        bz: "",
      },
      dialogTgState: false, //修改团购状态的开关
      titleBy: "",
      tableByLx: [],
      ByIndex: 1,
      BySize: 20,
      ByTotal: 0,
      isByAdd: false,
      formByLx: {
        title: "",
        stime: "",
        etime: "",
        state: 0,
        lx: 3,
      },
      initForm2: {},
      dialogByLx: false,
      ByLxSelection: [],
      ByOrderIndex: 1,
      dialogByOrder: false,
      ByOrderSize: 20,
      ByOrderTotal: 0,
      ByOrderUsername: "",
      dataByOrder: [],
      dialogByDetail: false,
      databyDetail: [],
      ByStime: "", //查询活动订单的开始时间
      ByEtime: "", //查询活动订单的结束时间
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  mounted() {
    this.searchSeckill();
    this.initForm = { ...this.formTgLx };
    this.initForm2 = { ...this.formByLx };
  },
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    status: function (status) {
      if (status == 4) {
        return "远程订单";
      } else {
        return "线下";
      }
    },
    TgOrderState(state) {
      if (state == "0") {
        return "初始状态";
      } else if (state == "1") {
        return "已付款";
      } else if (state == "2") {
        return "已生成订单";
      } else if (state == "-1") {
        return "已作废";
      }
    },
    TgGs(gs) {
      if (gs == 0) {
        return "电子商务公司";
      } else if (gs == 2) {
        return "工业公司";
      } else if (gs == 3) {
        return "西药公司";
      } else if (gs == 4) {
        return "新特药公司";
      } else if (gs == 5) {
        return "药品公司";
      } else if (gs == 6) {
        return "药材公司";
      }
    },
    addZero(val) {
      val = val + "";
      if (val.substr(0, 1) == ".") {
        val = "0" + val;
      }
      return Number(val);
    },
  },
  methods: {
    dateFormat(Date, fmt) {
      var o = {
        "M+": Date.getMonth() + 1, //月份
        "d+": Date.getDate(), //日
        "H+": Date.getHours(), //小时
        "m+": Date.getMinutes(), //分
        "s+": Date.getSeconds(), //秒
        "q+": Math.floor((Date.getMonth() + 3) / 3), //季度
        S: Date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (Date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    // 切换tab时
    handleClick(tab) {
      //
      if (tab.label == "秒杀管理") {
        this.searchSeckill();
      } else if (tab.label == "团购管理") {
        this.searchTgLx();
      } else if (tab.label == "订单改价") {
        this.getClerkStoreGoodsQuery();
      } else if (tab.label == "单品包邮") {
        this.searchByLx();
      } else if (tab.label == "产品展示") {
        this.getList();
      }
    },

    // 获取产品展示
    getList() {
      this.cpForm.pageIndex = 1;
      this.getCpList();
    },

    getCpList() {
      this.$http.post("DsApi/GetCxList", this.cpForm).then((res) => {
        if (res.data.isok) {
          this.cpData = res.data.data;
          this.cpTotal = res.data.recount
        } else {
          this.$message.error(res.data.message)
        }
      });
    },

    showCpModel() {
      this.clearForm();
      this.isCpAdd = true;
      this.dialogCpDrug = true;
    },

    // 选择药品
    chioseDrug() {
      this.getDrug();
      this.dialogDrug = true;
    },

    getDrug() {
      this.drugForm.pageIndex = 1;
      this.searchDrug();
    },

    // 获取基础药品
    searchDrug() {
      this.drugLoading = true;

      this.$http
        .post("DsApi/GetSearchList", {
          action: "alldrug",
          ...this.drugForm,
        })
        .then((res) => {
          this.drugLoading = false;
          if (res.data.isok) {
            this.dataDrug = res.data.data;
            this.DrugTotal = res.data.recount;
          }
        })
        .catch((err) => {
          this.drugLoading = false;
        });
    },

    clearForm() {
      this.formCpDrug = {
        ypmc: "",
        cdmc: "",
        gg: "",
        pzwh: "",
        ph: "",
        stepnum: 0,
        sl: 0,
        scrq: "",
        isretail: 0,
        yxq: "",
        image: "",
        drugid: "",
        topindex: 0,
      };

      this.hideUpload = false;
      this.fileList = [];
    },

    // 选择药品
    determine(item) {
      this.formCpDrug = {
        ypmc: item.ypmc,
        cdmc: item.cdmc,
        gg: item.gg,
        pzwh: item.pzwh,
        ph: item.ph,
        sl: item.sl,
        scrq: item.scrq,
        isretail: item.isretail,
        yxq: item.yxq,
        image: item.picname || "",
        drugid: item.id,
        topindex: 0,
      };

      this.fileList = [];
      this.hideUpload = false;
      if (item.picname) {
        this.fileList.push({
          url: this.baseUrl + item.picname,
        });
        this.hideUpload = true;
      }

      this.dialogDrug = false;
    },

    // 添加促销药品
    AddCxList() {
      if (!this.formCpDrug.ypmc) {
        return this.$message.error("请选择药品后再提交");
      }

      if (!this.formCpDrug.image) {
        this.formCpDrug.image = "/images/100.png";
      }

      this.$http.post("DsApi/AddCxList", this.formCpDrug).then((res) => {
        if (res.data.isok) {
          this.dialogCpDrug = false;
          this.getList();
          this.$message.success("添加成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 修改
    handleCpEdit(item) {
      this.isCpAdd = false;

      this.formCpDrug = {
        id: item.cxid,
        ypmc: item.ypmc,
        cdmc: item.cdmc,
        gg: item.gg,
        pzwh: item.pzwh,
        ph: item.ph,
        sl: item.sl,
        scrq: item.scrq,
        isretail: item.isretail,
        yxq: item.yxq,
        image: item.image || "",
        topindex: 0,
      };

      this.fileList = [];
      this.hideUpload = false;
      if (item.image) {
        this.fileList.push({
          url: this.baseUrl + item.image,
        });
        this.hideUpload = true;
      }

      this.dialogCpDrug = true;
    },

    handleTop(item) {
      this.formTop = {
        id: item.cxid,
        topindex: item.topindex,
        image: item.image,
      };

      this.dialogTop = true;
    },

    submitTop() {
      if (this.formTop.topindex != 0 && !this.formTop.topindex) {
        return this.$message.warning("请输入置顶数");
      }

      if (!this.formTop.image) {
        this.formTop.image = "/images/100.png";
      }

      this.$http
        .post("DsApi/UpdateCxList", { action: "update", ...this.formTop })
        .then((res) => {
          if (res.data.isok) {
            this.dialogTop = false;
            this.getList();
            this.$message.success("修改置顶数成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    UpdateCxList() {
      if (!this.formCpDrug.image) {
        this.formCpDrug.image = "/images/100.png";
      }

      this.$http
        .post("DsApi/UpdateCxList", { action: "update", ...this.formCpDrug })
        .then((res) => {
          if (res.data.isok) {
            this.dialogCpDrug = false;
            this.getList();
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    // 删除
    handleDel(item) {
      this.$confirm("此操作将删除该药品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("DsApi/UpdateCxList", {
              action: "del",
              id: item.cxid,
            })
            .then((res) => {
              if (res.data.isok) {
                this.getList();
                this.$message.success("删除成功");
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 所有药品Size发生改变时
    drugSizeChange(val) {
      this.drugForm.pageSize = val;
      this.searchDrug();
    },

    // 所有药品Index发生改变
    drugCurrentChange(val) {
      this.drugForm.pageIndex = val;
      this.searchDrug();
    },

    cpDrugCurrentChange(val) {
      this.cpForm.pageIndex = val;
      this.getCpList()
    },

    //上传图片
    uploadFile(params) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf("image") != -1;
      if (!isImage) {
        this.$message.error("只能上传图片格式png、jpg、gif!");
        return;
      }
      let param = new FormData(); // 创建form对象
      param.append("imgFile", file); //对应后台接收图片名
      param.append("username", window.sessionStorage.getItem("username"));
      param.append("tokenid", window.sessionStorage.getItem("tokenid"));
      param.append("phone_uuid", window.sessionStorage.getItem("phone_uuid"));
      // console.log(param.getAll("imgFile"))
      this.$http
        .post("Dls/UpLoadImage", param, {
          headers: {
            "Content-Type":
              "multipart/form-data;boundary =" + new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message({
              type: "success",
              message: "上传成功!",
            });
            this.hideUpload = true;
            this.formCpDrug.image = res.data.data;
          } else {
            this.hideUpload = false;
            this.$message.error(res.data.message);
            this.fileList = [];
          }
        })
        .catch((err) => {
          this.hideUpload = false;
          this.$message.error("服务器故障");
          this.fileList = [];
        });
    },

    //移除图片给提示
    handleRemove() {
      this.$message.error("图片已移除，请重新上传！");
      this.hideUpload = false;
      this.formCpDrug.image = "";
    },

    // 查询秒杀活动
    getSeckill() {
      this.pageIndex = 1;
      this.searchSeckill();
    },
    searchSeckill() {
      this.$http
        .post("DsApi/GetSearchList", {
          keys: this.title,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          action: "MsLx",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataSeckill = res.data.data;
            this.total = res.data.recount;
          }
        });
    },
    // 添加秒杀活动
    handleAdd() {
      this.isAdd = true;
      this.formSeckill = {
        title: "",
        stime: "",
        etime: "",
      };
      this.dialogSeckill = true;
    },
    // 添加/修改秒杀提交按钮
    submitUp() {
      if (this.isAdd) {
        this.$http.post("DsApi/AddMsLx", this.formSeckill).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchSeckill();
            this.dialogSeckill = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$http.post("DsApi/UpdateMsLx", this.formSeckill).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchSeckill();
            this.dialogSeckill = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //修改秒杀活动
    handleEdit(rows) {
      this.isAdd = false;
      this.formSeckill.title = rows.title;
      this.formSeckill.stime = rows.stime;
      this.formSeckill.etime = rows.etime;
      this.formSeckill.id = rows.id;
      this.dialogSeckill = true;
    },
    //删除秒杀活动
    handleDelete(rows) {
      this.$confirm("此操作将会永久删除这个秒杀主题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelMsLx(rows.id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //删除选中秒杀专题
    deleteChiose() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("对不起！您还未选中秒杀专题");
      } else {
        let id = this.multipleSelection.join();
        this.$confirm("此操作将永久删除这些秒杀专题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelMsLx(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //删除秒杀活动请求
    DelMsLx(id) {
      this.$http
        .post("DsApi/DelMsLx", {
          id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchSeckill();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //当秒杀活动列表的多选框被选择时
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => {
        return item.id;
      });
    },
    // 跳转到秒杀商品的页面
    toSeckill(rows) {
      this.$router.push({ name: "seckillDrug", params: { msid: rows.id } });
    },
    // 活动用户管理
    AddUser() {
      this.dialogUser = true;
      this.getUser();
    },
    // 搜索用户
    getUser() {
      this.userIndex = 1;
      this.searchUser();
    },
    // 查询用户
    searchUser() {
      this.$http
        .post("DsApi/GetSearchList", {
          keys: this.username,
          pageIndex: this.userIndex,
          pageSize: this.userSize,
          action: "msuser",
        })
        .then((res) => {
          //
          if (res.data.isok) {
            this.dataUser = res.data.data;
            this.userTotal = res.data.recount;
          }
        });
    },
    // 添加活动用户
    manageUser() {
      this.formUser.user = "";
      this.dialogManageUser = true;
    },
    // 确认添加用户
    confirm() {
      this.$http.post("DsApi/AddMsUser", this.formUser).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.dialogManageUser = false;
          this.searchUser();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 删除选中用户
    DelChioseUser() {
      if (this.userSelection.length == 0) {
        this.$message.error("对不起！您还未选中秒杀用户");
      } else {
        let id = this.userSelection.join();
        this.$confirm("此操作将永久删除这些秒杀用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelUser(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 删除用户
    userDelete(rows) {
      this.$confirm("此操作将会永久删除这个秒杀用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let id = rows.id;
          this.DelUser(id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除用户
    DelUser(id) {
      this.$http
        .post("DsApi/DelMsUser", {
          id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchUser();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 活动用户列表被选中时
    userChange(val) {
      this.userSelection = val.map((item) => {
        return item.id;
      });
    },
    // 打开秒杀订单
    checkOrders() {
      this.dialogSecOrder = true;
      this.getSecOrder();
    },
    //获取秒杀订单
    getSecOrder() {
      this.secOrderIndex = 1;
      this.searchSecOrder();
    },
    searchSecOrder() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.secStime = this.secStime ? this.secStime : startTime;
      this.secEtime = this.secEtime
        ? this.secEtime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.secOrderIndex,
          pageSize: this.secOrderSize,
          keys: this.secUser,
          stime: this.secStime,
          etime: this.secEtime,
          action: "msorders",
        })
        .then((res) => {
          if (res.data.isok) {
            //
            this.dataSecOrder = res.data.data;
            this.secOrderTotal = res.data.recount;
          }
        });
    },
    // 获取秒杀订单详情
    checkSecDetail(rows) {
      this.$http
        .post("DsApi/GetSearchList", {
          orderid: rows.orderid,
          isms: 1,
          action: "orders_detail",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataSecDetail = res.data.data;
            this.dialogSecDetail = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //秒杀详情判断
    tableRowClassNameSec({ row, rowIndex }) {
      if (row.isms != 0) {
        return "danger-row";
      }
    },
    //添加团购活动
    handleAddTgLx() {
      this.isTgAdd = true;
      this.formTgLx = { ...this.initForm };
      this.dialogTgLx = true;
    },
    //修改/添加团购活动的提交按钮
    handleSubmit() {
      if (this.isTgAdd) {
        if (this.formTgLx.title == "") {
          this.$message.warning("对不起，团购标题不可为空！");
        } else if (this.formTgLx.stime == "") {
          this.$message.warning("对不起，您还没有选择团购开始时间！");
        } else if (this.formTgLx.etime == "") {
          this.$message.warning("对不起，您还没有选择团购结束时间！");
        } else {
          this.$http.post("DsApi/AddTgLx", this.formTgLx).then((res) => {
            if (res.data.isok) {
              this.$message.success(res.data.message);
              this.searchTgLx();
              this.dialogTgLx = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      } else {
        this.$http.post("DsApi/UpdateTgLx", this.formTgLx).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchTgLx();
            this.dialogTgLx = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    getTgLx() {
      this.TgIndex = 1;
      this.searchTgLx();
    },
    //获取团购列表
    searchTgLx() {
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.TgIndex,
          pageSize: this.TgSize,
          keys: this.titleTg,
          action: "TgLx",
          lx: 2,
        })
        .then((res) => {
          if (res.data.isok) {
            this.tableTgLx = res.data.data;
            this.TgTotal = res.data.recount;
          }
        });
    },
    // 当团购列表的多选框被选择时
    TglxChange(val) {
      this.TgLxSelection = val.map((item) => {
        return item.id;
      });
    },
    // 当团购状态发生改变时
    changeState(rows) {
      this.$http
        .post("DsApi/UpdateTgLx", {
          title: rows.title,
          stime: rows.stime,
          etime: rows.etime,
          id: rows.id,
          state: rows.state,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchTgLx();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 修改团购类型
    handleEditTgLx(rows) {
      this.formTgLx.id = rows.id;
      this.formTgLx.title = rows.title;
      this.formTgLx.stime = rows.stime;
      this.formTgLx.etime = rows.etime;
      this.formTgLx.state = rows.state;
      this.isTgAdd = false;
      this.dialogTgLx = true;
    },
    //删除选中的团购活动
    deleteChioseTgLx() {
      if (this.TgLxSelection.length == 0) {
        this.$message.error("对不起！您还未选中团购专题");
      } else {
        let id = this.TgLxSelection.join();
        this.$confirm("此操作将永久删除这些团购专题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelTgLx(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 删除团购主题
    handleDeleteTgLx(rows) {
      this.$confirm("此操作将会永久删除这个团购主题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelTgLx(rows.id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除团购活动请求
    DelTgLx(id) {
      this.$http.post("DsApi/DelTgLx", { id }).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.searchTgLx();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //跳转到团购药品页面
    toTgDrug(rows) {
      this.$router.push({ name: "tgDrug", params: { tgid: rows.id } });
    },
    //跳转到单品包邮页面
    toByDrug(rows) {
      this.$router.push({ name: "byDrug", params: { byid: rows.id } });
    },
    //打开团购订单弹框
    openTgOrder() {
      this.getTgOrder();
      this.dialogTgOrder = true;
    },
    getTgOrder() {
      this.TgOrderIndex = 1;
      this.searchTgOrder();
    },
    // 获取团购订单列表
    searchTgOrder() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.TgStime = this.TgStime ? this.TgStime : startTime;
      this.TgEtime = this.TgEtime
        ? this.TgEtime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.TgOrderIndex,
          pageSize: this.TgOrderSize,
          keys: this.TgOrderUsername,
          stime: this.TgStime,
          etime: this.TgEtime,
          action: "tgorders",
          gs: this.TgGs,
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataTgOrder = res.data.data;
            this.TgOrderTotal = res.data.recount;
          }
        });
    },
    // 获取团购订单详情
    checkTgDetail(rows) {
      this.$http
        .post("DsApi/GetSearchList", {
          orderid: rows.orderid,
          isms: 2,
          action: "orders_detail",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataTgDetail = res.data.data;
            this.dialogTgDetail = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 团购订单详情判断
    tableRowClassNameTg({ row, rowIndex }) {
      //
      if (row.isms != 0) {
        return "danger-row";
      }
    },
    //修改订单状态
    handleEditTgOrder(rows) {
      this.formTgOrder.id = rows.id;
      this.formTgOrder.state = rows.state;
      this.formTgOrder.bz = rows.bz;
      this.dialogTgState = true;
    },
    // 修改订单的提交按钮
    submitState() {
      this.$http.post("DsApi/UpdateTgOrders", this.formTgOrder).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.dialogTgState = false;
          this.searchTgOrder();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 秒杀用户Size发生改变时
    userSizeChange(val) {
      this.userSize = val;
      this.searchUser();
    },
    // 秒杀用户Index发生改变
    userCurrentChange(val) {
      this.userIndex = val;
      this.searchUser();
    },
    // 秒杀活动Size发生改变时
    SizeChange(val) {
      this.pageSize = val;
      this.searchSeckill();
    },
    // 秒杀活动Index发生改变
    CurrentChange(val) {
      this.pageIndex = val;
      this.searchSeckill();
    },
    // 秒杀订单Size发生改变时
    secOrderSizeChange(val) {
      this.secOrderSize = val;
      this.searchSecOrder();
    },
    // 秒杀订单Index发生改变
    secOrderCurrentChange(val) {
      this.secOrderIndex = val;
      this.searchSecOrder();
    },
    //团购活动Size发生变化时
    TgLxSizeChange(val) {
      this.TgSize = val;
      this.searchTgLx();
    },
    //团购活动Index发生变化时
    TgLxCurrentChange(val) {
      this.TgIndex = val;
      this.searchTgLx();
    },
    //团购订单Size发生变化时
    TgOrderSizeChange(val) {
      this.TgOrderSize = val;
      this.searchTgOrder();
    },
    //团购订单Index发生变化时
    TgOrderCurrentChange(val) {
      this.TgOrderIndex = val;
      this.searchTgOrder();
    },
    //获取短信验证码
    getCode() {
      const that = this;
      //
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.phoneNumber) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.phoneNumber)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        this.interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(this.interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.phoneNumber })
        .then((response) => {
          //
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },
    //确认修改
    Modification: async function () {
      const that = this;
      // let reg1 = /^[0-9]{6}$/;
      that.disabled1 = true;
      await that.$http
        .post("/Dls/SaleOrderTradePriceAdjustds", {
          id: that.id,
          upPrice: that.ModifyPrice,
          gatherNo: that.gatherNoCount,
          StoreNo: that.StoreNo,
          storeID: that.storeID,
          state: that.state,
          netOrderNo: that.netOrderNo,
          phone: that.phoneNumber,
          yzm: that.securityCode,
        })
        .then((response) => {
          //
          if (response.data.isOk) {
            if (response.data.data.isSucceed) {
              $("#myModal_jia").modal("hide");
              that.disabled1 = false;
              alert(response.data.data.msg);
              //重新赋值
              this.tableData[this.index].amount = response.data.data.amount;
              this.tableData[this.index].price = response.data.data.price;
              this.tableData[this.index].tradePrice =
                response.data.data.tradePrice;
            } else {
              that.disabled1 = false;
              alert(response.data.data.msg);
            }

            //这里重新获取列表
            // that.getClerkStoreGoodsQuery();
          } else if (!response.data.isok) {
            that.disabled1 = false;
            alert(response.data.message);
          }
        });
    },
    //这里是传入价格，并且对价格进行判断
    GetTiaoJia: async function (index) {
      this.index = index;
      const that = this;
      that.ModifyPrice = that.tableData[index].value;
      that.BeforePrice = that.tableData[index].tradePrice;
      that.id = that.tableData[index].id;
      that.gatherNoCount = that.tableData[index].gatherNo;
      that.StoreNo = that.tableData[index].StoreNo;
      that.storeID = that.tableData[index].storeID;
      that.state = that.tableData[index].state;
      that.netOrderNo = that.tableData[index].netOrderNo;
      let reg = /^(?!0+$)(?!0*\.0*$)\d{1,5}(\.\d{1,3})?$/;
      if (!that.ModifyPrice) {
        alert("您输入的价格不能为空！");
      } else if (!reg.test(that.ModifyPrice)) {
        alert("输入价格不能带负数，必须为纯数字，小数点最多三位！");
      } else if (that.ModifyPrice >= that.BeforePrice) {
        alert("价格只能调低!");
      } else {
        //这里先判断有没有手机
        // await that.isPhones();
        $("#myModal_jia").modal();
      }
    },
    //判读是否有手机号
    // isPhones() {
    //   const that = this;
    //   that.$http.post("/Dls/GetPhone", {}).then((response) => {
    //     //
    //     if (response.data.isOk) {
    //       that.phones = response.data.data.rows;
    //       //

    //       $("#myModal_jia").modal();
    //     } else {
    //       alert(response.data.message);
    //     }
    //   });
    // },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },

    getClerkStoreGoodsQuery: async function () {
      // this.isLoading=true;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "SaleOrderAdjustSearch",
        obj: JSON.stringify({
          gatherNo: this.gatherNo.trim(),
          customerName: this.customerName.trim(),
          drugName: this.drugName.trim(),
        }),
      });
      //
      if (res.isok) {
        this.showVue = true;
        const obj = res.data;
        this.tableData = obj.rows;
        if (this.tableData.length > 0) {
          this.showPage = true;
        } else {
          this.showPage = false;
        }
      }
    },
    // 添加单品包邮活动
    handleAddByLx() {
      this.isByAdd = true;
      this.formByLx = { ...this.initForm2 };
      this.dialogByLx = true;
    },
    //修改/添加团购活动的提交按钮
    handleBySubmit() {
      // console.log(this.formByLx)
      if (this.isByAdd) {
        if (this.formByLx.title == "") {
          this.$message.warning("对不起，活动标题不可为空！");
        } else if (this.formByLx.stime == "") {
          this.$message.warning("对不起，您还没有选择活动开始时间！");
        } else if (this.formByLx.etime == "") {
          this.$message.warning("对不起，您还没有选择活动结束时间！");
        } else {
          this.$http.post("DsApi/AddTgLx", this.formByLx).then((res) => {
            if (res.data.isok) {
              this.$message.success(res.data.message);
              this.searchByLx();
              this.dialogByLx = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      } else {
        this.$http.post("DsApi/UpdateTgLx", this.formByLx).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchByLx();
            this.dialogByLx = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    getByLx() {
      this.ByIndex = 1;
      this.searchByLx();
    },
    //获取团购列表
    searchByLx() {
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.ByIndex,
          pageSize: this.BySize,
          keys: this.titleBy,
          action: "TgLx",
          lx: 3,
        })
        .then((res) => {
          if (res.data.isok) {
            this.tableByLx = res.data.data;
            this.ByTotal = res.data.recount;
          }
        });
    },
    // 当团购列表的多选框被选择时
    BylxChange(val) {
      this.ByLxSelection = val.map((item) => {
        return item.id;
      });
    },
    // 当团购状态发生改变时
    changeByState(rows) {
      this.$http
        .post("DsApi/UpdateTgLx", {
          title: rows.title,
          stime: rows.stime,
          etime: rows.etime,
          id: rows.id,
          state: rows.state,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchByLx();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 修改活动类型
    handleEditByLx(rows) {
      this.formByLx.id = rows.id;
      this.formByLx.title = rows.title;
      this.formByLx.stime = rows.stime;
      this.formByLx.etime = rows.etime;
      this.formByLx.state = rows.state;
      this.isByAdd = false;
      this.dialogByLx = true;
    },
    //删除选中的活动
    deleteChioseByLx() {
      if (this.ByLxSelection.length == 0) {
        this.$message.error("对不起！您还未选中团购专题");
      } else {
        let id = this.ByLxSelection.join();
        this.$confirm("此操作将永久删除这些团购专题, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelByLx(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 删除活动主题
    handleDeleteByLx(rows) {
      this.$confirm("此操作将会永久删除这个团购主题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.DelByLx(rows.id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除活动请求
    DelByLx(id) {
      this.$http.post("DsApi/DelTgLx", { id }).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.searchByLx();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //活动Size发生变化时
    ByLxSizeChange(val) {
      this.BySize = val;
      this.searchByLx();
    },
    //活动Index发生变化时
    ByLxCurrentChange(val) {
      this.ByIndex = val;
      this.searchByLx();
    },
    //打开活动订单弹框
    openByOrder() {
      this.getByOrder();
      this.dialogByOrder = true;
    },
    getByOrder() {
      this.ByOrderIndex = 1;
      this.searchByOrder();
    },
    // 获取团购订单列表
    searchByOrder() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.ByStime = this.ByStime ? this.ByStime : startTime;
      this.ByEtime = this.ByEtime
        ? this.ByEtime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.ByOrderIndex,
          pageSize: this.ByOrderSize,
          keys: this.ByOrderUsername,
          stime: this.ByStime,
          etime: this.ByEtime,
          action: "tgorders2",
          gs: this.TgGs,
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataByOrder = res.data.data;
            this.ByOrderTotal = res.data.recount;
          }
        });
    },
    // 获取活动订单详情
    checkByDetail(rows) {
      this.$http
        .post("DsApi/GetSearchList", {
          orderid: rows.orderid,
          isms: 2,
          action: "orders_detail",
        })
        .then((res) => {
          if (res.data.isok) {
            this.databyDetail = res.data.data;
            this.dialogByDetail = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 活动订单详情判断
    tableRowClassNameBy({ row, rowIndex }) {
      //
      if (row.isms != 0) {
        return "danger-row";
      }
    },
    //活动订单Size发生变化时
    ByOrderSizeChange(val) {
      this.ByOrderSize = val;
      this.searchByOrder();
    },
    //活动订单Index发生变化时
    ByOrderCurrentChange(val) {
      this.ByOrderIndex = val;
      this.searchByOrder();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
/deep/ tr td {
  font-size: 12px;
}
/deep/ .el-table .danger-row {
  background: #f9ebeb;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
}
.input_form-control {
  /* // display: block;  */
  width: 20%;
  height: 24px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}

.input_form-control1 {
  /* // display: block;  */
  width: 50%;
  height: 38px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control1:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control1.button_zi {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Activity.vue